import React from "react";
import moment from "moment";

export const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
  },
  {
    title: "酒店名称",
    dataIndex: "hotel_name",
    key: "hotel_name",
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "职位",
    dataIndex: "position",
    key: "position",
  },
  {
    title: "合同起始时间",
    dataIndex: "start_time",
    key: "start_time",
  },
  {
    title: "合同截止时间",
    dataIndex: "end_time",
    key: "end_time",
    render: (text, record, i) => {
      if (moment(text).isBefore(moment().add(3, "M")))
        return <span style={{ color: "red" }}>{text}</span>;
      return text;
    },
  },
  {
    title: "试用到期时间",
    dataIndex: "trial",
    key: "trial",
    render: (text, record, i) => {
      if (moment(text).isBefore(moment().add(3, "M")))
        return <span style={{ color: "red" }}>{text}</span>;
      return text;
    },
  },
  {
    title: "是否开启提醒",
    dataIndex: "is_remind",
    key: "is_remind",
    render: (text, record, i) => {
      return (
        <span style={{ color: record.is_remind == 1 ? "#4C9BF2" : "" }}>
          {record.is_remind == 1 ? "提醒" : "不提醒"}
        </span>
      );
    },
  },
  {
    title: "备注",
    dataIndex: "note",
    key: "note",
    render: (text) => {
      return <span className="note">{text || ""}</span>;
    },
  },
];

export const defaultData = {
  hotel_name: "",
  name: "",
  position: "",
  start_time: "",
  end_time: "",
  trial: "",
  note: "",
  file: "",
  email: [],
};



// WEBPACK FOOTER //
// ./src/components/contract/data.js